export default __webpack_public_path__ + "static/media/ice-viking.9000eead.jpeg";